import { lazy, ComponentType } from 'react';

/**
 * A wrapper for React.lazy that handles "Failed to fetch dynamically imported module" errors.
 * This typically happens when a new build is deployed and the user's browser is trying
 * to load a stale chunk that no longer exists on the server.
 */
export const lazyWithRetry = (componentImport: () => Promise<{ default: ComponentType<any> }>) =>
  lazy(async () => {
    const pageHasBeenForceRefreshed = JSON.parse(
      window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem('page-has-been-force-refreshed', 'false');
      return component;
    } catch (error) {
      if (!pageHasBeenForceRefreshed) {
        // We only want to refresh once.
        window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');
        window.location.reload();
      }

      // If we already refreshed and it's still failing, then it's a real error.
      throw error;
    }
  });
